import { Box } from '@mui/material';
import { Icon } from '@mui/material';
import React from 'react';

import { useSxStyles } from './useStyles';

type Props = {
  pendingCondition: boolean;
  pendingValue: string | React.ReactNode;
  isColorGreen?: boolean;
};

export const PendingEmploymentComponent = ({
  pendingCondition,
  pendingValue,
  isColorGreen,
}: Props) => {
  const sxStyles = useSxStyles();
  if (!pendingCondition) {
    return <></>;
  }

  return (
    <Box
      component="span"
      sx={isColorGreen ? sxStyles.pendingGreen : sxStyles.pendingBlue}
    >
      <Icon className="fa fa-long-arrow-right" sx={sxStyles.icon} />
      {pendingValue}
    </Box>
  );
};
